import React from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const current = i18n.language;

  const toggle = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
  };

  return (
    <div className="lang-switcher">
      <button
        className={`btn-transparent lang-switcher__btn${current === 'en' ? ' lang-switcher__btn--active' : ''}`}
        onClick={() => toggle('en')}
      >
        EN
      </button>
      <span className="lang-switcher__sep">|</span>
      <button
        className={`btn-transparent lang-switcher__btn${current === 'ru' ? ' lang-switcher__btn--active' : ''}`}
        onClick={() => toggle('ru')}
      >
        RU
      </button>
    </div>
  );
};
